export const environmentversion = {
  version : 'detached(da8d3092e1b45c3bcd3eab604017fd81e68c3a71)'
};